import compat from '../common/compat';

export default Object.assign(compat, {});
